import { 
  ScatterChart as SChart, 
  Scatter,Legend,
  XAxis, YAxis, CartesianGrid, Tooltip, 
} from 'recharts';

import {COLORS,} from './utils';


export const ScatterChart = ({commonProps,widget,data }:any) =>{

    return (
        <SChart {...commonProps}>
            <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
            <XAxis dataKey={widget.xKey} stroke="#6b7280" />
            <YAxis dataKey={Array.isArray(widget.dataKey) ? widget.dataKey[0] : widget.dataKey} stroke="#6b7280" />
            <Tooltip 
                cursor={{ strokeDasharray: '3 3' }}
                contentStyle={{ 
                background: 'white', 
                border: '1px solid #e5e7eb',
                borderRadius: '6px'
                }} 
            />
            <Legend />
            <Scatter 
                name={Array.isArray(widget.dataKey) ? widget.dataKey[0] : widget.dataKey}
                data={data} 
                fill={COLORS[0]}
            />
        </SChart>
    )

}